module.exports = __webpack_public_path__ + "static/media/km.d8f67ce3.svg";